// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/anise_logo_white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_Footer__MEpnh {
  background-color: #015d8e;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  padding-top: 30px;
}
.Footer_Footer__MEpnh .Footer_container__iICw7 {
  max-width: 1300px;
  align-self: center;
  gap: 50px;
  width: 100%;
  height: 100%;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  position: static;
  padding: 50px 0;
}
.Footer_Footer__MEpnh .Footer_container__iICw7 .Footer_logo_side__Urw1- {
  flex: 0.35 1;
}
.Footer_Footer__MEpnh .Footer_container__iICw7 .Footer_logo_side__Urw1- span {
  font-size: 13px;
}
.Footer_Footer__MEpnh .Footer_container__iICw7 .Footer_logo_side__Urw1- .Footer_logo__w79hm {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 50px;
  width: 157px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 15px;
}
.Footer_Footer__MEpnh .Footer_container__iICw7 .Footer_form_side__XKVdS {
  flex: 0.4 1;
}
.Footer_Footer__MEpnh .Footer_container__iICw7 .Footer_form_side__XKVdS form {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  width: 100%;
}
.Footer_Footer__MEpnh .Footer_container__iICw7 .Footer_footer_header__W4\\+rf {
  margin-top: 0px;
  font-size: 17px;
  text-transform: uppercase;
}
.Footer_Footer__MEpnh .Footer_container__iICw7 ul {
  list-style-position: inside;
  padding-left: 0;
}
.Footer_Footer__MEpnh .Footer_container__iICw7 ul li {
  list-style: none;
  margin-bottom: 10px;
  font-size: 14px;
  list-style-position: inside;
  display: flex;
  align-items: center;
}
.Footer_Footer__MEpnh .Footer_container__iICw7 ul li a {
  color: #ffffff;
  margin-right: 5px;
}
.Footer_Footer__MEpnh .Footer_container__iICw7 ul li .Footer_front_link_icon__3isMX {
  margin-right: 10px;
}
.Footer_Footer__MEpnh .Footer_container__iICw7 ul li .Footer_link_icon__OIkwF svg {
  transform: rotate(-45deg);
}
.Footer_Footer__MEpnh .Footer_footer_owner__5C13P {
  max-width: 1300px;
  width: 100%;
  padding: 10px 0;
  text-align: center;
  font-size: 12px;
  border-top: 1px solid #ffbc51;
}
@media (max-width: 768px) {
  .Footer_Footer__MEpnh {
    padding: 0 20px;
    padding-bottom: 30px;
  }
  .Footer_Footer__MEpnh .Footer_container__iICw7 {
    flex-direction: column;
  }
  .Footer_Footer__MEpnh .Footer_container__iICw7 .Footer_form_side__XKVdS form {
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACE,yBCCgB;EDAhB,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;AADF;AAGE;EACE,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;AADJ;AAGI;EACE,YAAA;AADN;AAGM;EACE,eAAA;AADR;AAIM;EACE,yDAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;AAFR;AAMI;EACE,WAAA;AAJN;AAMM;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,WAAA;AAJR;AAQI;EACE,eAAA;EACA,eAAA;EACA,yBAAA;AANN;AASI;EACE,2BAAA;EACA,eAAA;AAPN;AAUI;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AARN;AAUM;EACE,cAAA;EACA,iBAAA;AARR;AAWM;EACE,kBAAA;AATR;AAaQ;EACE,yBAAA;AAXV;AAiBE;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AAfJ;AAkBE;EAhGF;IAiGI,eAAA;IACA,oBAAA;EAfF;EAiBE;IACE,sBAAA;EAfJ;EAkBM;IACE,mBAAA;EAhBR;AACF","sourcesContent":["@import '../../variables';\n\n.Footer {\n  background-color: $secondary-color;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  padding-top: 30px;\n\n  .container {\n    max-width: 1300px;\n    align-self: center;\n    gap: 50px;\n    width: 100%;\n    height: 100%;\n    font-weight: 500;\n    display: flex;\n    justify-content: space-between;\n    position: static;\n    padding: 50px 0;\n\n    .logo_side {\n      flex: 0.35;\n\n      span {\n        font-size: 13px;\n      }\n\n      .logo {\n        background-image: url('../../assets/images/anise_logo_white.svg');\n        height: 50px;\n        width: 157px;\n        background-position: center;\n        background-size: cover;\n        background-repeat: no-repeat;\n        margin-bottom: 15px;\n      }\n    }\n\n    .form_side {\n      flex: 0.4;\n\n      form {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        gap: 10px;\n        width: 100%;\n      }\n    }\n\n    .footer_header {\n      margin-top: 0px;\n      font-size: 17px;\n      text-transform: uppercase;\n    }\n\n    ul {\n      list-style-position: inside;\n      padding-left: 0;\n    }\n\n    ul li {\n      list-style: none;\n      margin-bottom: 10px;\n      font-size: 14px;\n      list-style-position: inside;\n      display: flex;\n      align-items: center;\n\n      a {\n        color: #ffffff;\n        margin-right: 5px;\n      }\n\n      .front_link_icon {\n        margin-right: 10px;\n      }\n\n      .link_icon {\n        svg {\n          transform: rotate(-45deg);\n        }\n      }\n    }\n  }\n\n  .footer_owner {\n    max-width: 1300px;\n    width: 100%;\n    padding: 10px 0;\n    text-align: center;\n    font-size: 12px;\n    border-top: 1px solid $primary-color;\n  }\n\n  @media (max-width: 768px) {\n    padding: 0 20px;\n    padding-bottom: 30px;\n\n    .container {\n      flex-direction: column;\n\n      .form_side {\n        form {\n          align-items: center;\n        }\n      }\n    }\n  }\n}\n","// _variables.scss\n\n$primary-color: #ffbc51;\n$primary-dark-color: #d99221;\n$secondary-color: #015d8e;\n$secondary-dark-color: #0b4b6d;\n$white-color: #ffffff;\n$black-color: #212121;\n$black-dark-color: #000000;\n$card-border-color: #e3ebf2;\n$input-background-color: #fafafa;\n\n$border-radius: 8px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Footer": `Footer_Footer__MEpnh`,
	"container": `Footer_container__iICw7`,
	"logo_side": `Footer_logo_side__Urw1-`,
	"logo": `Footer_logo__w79hm`,
	"form_side": `Footer_form_side__XKVdS`,
	"footer_header": `Footer_footer_header__W4+rf`,
	"front_link_icon": `Footer_front_link_icon__3isMX`,
	"link_icon": `Footer_link_icon__OIkwF`,
	"footer_owner": `Footer_footer_owner__5C13P`
};
export default ___CSS_LOADER_EXPORT___;
